import { getClosestSelectionTable } from '@lib/popups';
import { MultiSelectDropdown } from '@ui/MultiSelectDropdown';
import { useUsers } from '@hooks';
import React, { useMemo } from 'react';
function mapUserToOption(user) {
    return {
        label: user.fullName,
        value: String(user.id)
    };
}
export const AssignedToFilter = (props) => {
    const users = useUsers(true);
    const options = useMemo(() => { var _a; return (_a = users.map(mapUserToOption)) !== null && _a !== void 0 ? _a : []; }, [users]);
    return React.createElement(MultiSelectDropdown, Object.assign({}, props, { getPopupContainer: getClosestSelectionTable, options: options }));
};
